// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wr_a bic_b","TwoDimsListFeature__item":"wr_b bic_we","TwoDimsListFeature__item__text":"wr_c bic_vt"};